var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.8 3.298l1.401-1.426 5.514 5.415a1 1 0 0 1 0 1.426L6.2 14.128l-1.4-1.426L9.587 8 4.8 3.298z","fill":"currentColor"}));
}

ChevronRightInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
